export const checklist_theme = {
  openMenuTheme: 'Ouvrir menu theme',
  confirmNotApplicationText:
    "Si le thème n'est pas d'application, les valeurs seront perdues. Voulez vous confirmer ?",
  confirmNotApplicationTitle: "Confirmer le thème comme pas d'application",
};
